import gql from 'graphql-tag'

export const ADD_PINJOB = gql`
mutation (
	$titles: [inputTitle]
	$openingDate: Date
	$closingDate: Date
	$tags: [String]
	$facebookLink: String
	$file: String
	$employerId: ID
	$jobFunctionId: [ID]
	$description: String
	$shareImage:String
) {
	addPinJob(
		info: {
			titles: $titles
			openingDate: $openingDate
			closingDate: $closingDate
			tags: $tags
			facebookLink: $facebookLink
			file: $file
			employerId: $employerId
			jobFunctionId: $jobFunctionId
			description: $description
			shareImage:$shareImage
		}
	) {
		_id
		titles{title qty}
		openingDate
		closingDate
		tags
		facebookLink
		file
		employerId {
			_id
		}
		jobFunctionId{_id}
		description
		shareImage
	}
}


`

export const PINJOB_LIST = gql`
query (
	$type:String
    $page:Int
	$perPage:Int
	$search:String
) {
	getPinJob(
	 type:$type	page:$page perPage:$perPage search:$search
	){
		infoList{
			_id
			titles{title qty}
			openingDate
			closingDate
			employerId{
				_id,
				companyName
			}
			file
			shareImage
		}
		totals
	}
}

`

export const EDIT_PINJOB = gql`
query (
$_id:ID
) {
	editPinJob(
	_id:$_id
	){
		_id
		titles{title qty}
		openingDate
		closingDate
		employerId{_id companyName} 
		file
		facebookLink
		tags
		jobFunctionId{
			_id 
			name}
		description
		shareImage
}
}
`
export const UPDATE_PINJOB = gql`
mutation (
	$_id:ID!
	$titles: [inputTitle]
	$openingDate: Date
	$closingDate: Date
	$tags: [String]
	$facebookLink: String
	$file: String
	$employerId: ID
	$jobFunctionId: [ID]
	$description: String
	$shareImage:String
) {
	updatePinJob(
		info: {
			_id:$_id
			titles: $titles
			openingDate: $openingDate
			closingDate: $closingDate
			tags: $tags
			facebookLink: $facebookLink
			file: $file
			employerId: $employerId
			jobFunctionId: $jobFunctionId
			description: $description
			shareImage:$shareImage
		}
	) 
}

`